// extracted by mini-css-extract-plugin
module.exports = {"BlogFeed":"styles_BlogFeed__r2CKs","bg_1":"styles_bg_1__igSvN","height":"styles_height__mZoPx"};